export default __webpack_public_path__ + "static/media/WALLPAPER.04b12c47.png";